import { EntityKind, buildBusinessErrorFromError, } from '@mgdis/eu-domain';
export class DemandesComplementPiecesRestAdapter {
    #httpAdapter;
    constructor({ restHttpAdapter }) {
        this.#httpAdapter = restHttpAdapter;
    }
    /**
     * Call API: get demande complement pieces with pieces.documents expanded
     *
     * @param demandeComplementPiecesId - demande complement pieces id
     * @returns demande complement pieces with pieces.documents expanded
     */
    async getWithDocuments(demandeComplementPiecesId) {
        try {
            const result = await this.#httpAdapter.get(`${demandeComplementPiecesId}?expand=pieces.documents`);
            return { response: result.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error, { entityKind: EntityKind.DEMANDE_COMPLEMENT_PIECES }) };
        }
    }
    /**
     * Call API: update demande complement pieces
     *
     * @param demandeComplementPieces - full demande complement pieces entity to update
     * @returns updated demande complement pieces
     */
    async update(demandeComplementPieces) {
        try {
            const result = await this.#httpAdapter.put(demandeComplementPieces.id, demandeComplementPieces);
            return { response: result.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error, { entityKind: EntityKind.DEMANDE_COMPLEMENT_PIECES }) };
        }
    }
}
//# sourceMappingURL=demandes-complement-pieces-rest.adapter.js.map